import { PageLoading } from "@fp/ui/components/base/page-layout/page-layout";
import { createFileRoute } from "@tanstack/react-router";
import { ReportExportDownloadPage } from "@/components/report-export-download-page";
import { unpaidCompletedWorkReportExportClient } from "@/lib/report-export-clients";

export const Route = createFileRoute("/unpaid-completed-work-report-downloads/$id")({
	component: RouteComponent,
	pendingComponent: () => <PageLoading />,
});

function RouteComponent() {
	const { id } = Route.useParams();

	return <ReportExportDownloadPage exportId={id} client={unpaidCompletedWorkReportExportClient} />;
}
